export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        tax_identifier_short: "Tax ID",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
        ornz: "ORNZ",
        ogrn: "OGRN",
        research_email: "Research email",
        lead_priority: "Sales priority",
        lead_priority_rank: "Sales priority",
        lead_score: "Lead score",
        decision_maker: "Decision maker",
        decision_maker_role: "Decision-maker role",
        decision_maker_profile_url: "Decision-maker profile",
        website_status: "Website status",
        digital_maturity_score: "Digital maturity",
        specializations: "Specializations",
        social_profile_count: "Social profiles",
        has_vacancy_signal: "Has hiring signal",
        vacancy_freshness: "Vacancy freshness",
        has_cases_clients: "Has cases or clients",
        personalized_reason: "Personalized sales reason",
        research_checked_at: "Research date",
        research_source_urls: "Research sources",
        revenue_2025_thousand_rub: "2025 revenue, RUB thousands",
        marketing_consent_status: "Advertising consent status",
        marketing_consent_channel: "Consent channel",
        marketing_consent_granted_at: "Consent date and time",
        marketing_consent_evidence_url: "Consent evidence URL",
        do_not_contact: "Do not contact",
        sro_membership_status: "SRO membership status",
        sro_membership_ended_at: "Membership end date",
        sro_membership_end_reason: "Membership end reason",
        sro_membership_checked_at: "Membership checked date",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
        sales_intelligence: "Sales intelligence",
        contact_permission: "Contact permission",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      auditors_count_value:
        "%{smart_count} auditor |||| %{smart_count} auditors",
      priority: {
        high: "High",
        medium: "Medium",
        low: "Low",
      },
      sro_membership: {
        active: "Membership active",
        ceased: "Membership ceased",
      },
      consent_status: {
        unknown: "Consent not confirmed",
        requested: "Consent requested",
        granted: "Consent confirmed",
        revoked: "Consent revoked",
        stop_list: "Stop list",
      },
      consent_channel: {
        phone: "Phone",
        email: "Email",
        messenger: "Messenger",
        form: "Website form",
        event: "Event",
        referral: "Referral",
        contract: "Contract",
        not_set: "Channel not set",
      },
      digital_maturity: {
        high: "High: 8–10",
        medium: "Medium: 5–7",
        low: "Low: 0–4",
      },
      sales: {
        score: "Score %{score}",
        digital_maturity: "Digital maturity %{score}/10",
        social_profiles:
          "%{smart_count} social profile |||| %{smart_count} social profiles",
        has_cases_clients: "Has cases/clients",
        has_vacancy_signal: "Has hiring signal",
        more_specializations: "+%{smart_count}",
        research_checked_at: "Research checked: %{date}",
        sources: "%{smart_count} source |||| %{smart_count} sources",
        public_contact_notice:
          "A public contact detail is not consent to receive advertising.",
        sro_membership_ceased:
          "Excluded from the active sales queue because SRO membership has ceased.",
      },
      sizes: {
        one_to_three_active_auditors: "1-3",
        four_to_ten_active_auditors: "4-10",
        eleven_to_twenty_five_active_auditors: "11-25",
        twenty_six_to_fifty_active_auditors: "26-50",
        more_than_fifty_active_auditors: "50+",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
      filters: {
        auditors_count: "Auditors count",
        all_cities: "All cities",
        all_managers: "All account managers",
        all_regions: "All regions",
        city_region: "City/region",
        no_regions: "No regions found",
        only_mine: "Only companies I manage",
        search: "Search companies",
        search_city: "Search city",
        search_region: "Search region",
        sales_priority: "Sales priority",
        specialization: "Specialization",
        all_specializations: "All specializations",
        sales_signals: "Sales signals",
        with_social_profiles: "Has social profiles",
        with_cases_clients: "Has cases/clients",
        with_vacancy_signal: "Has hiring signal",
        with_reachable_website: "Website reachable",
        digital_maturity: "Digital maturity",
        contact_permission: "Contact permission",
        sro_membership_status: "SRO membership status",
      },
      import: {
        title: "Import companies",
        button: "Import CSV",
        complete:
          "Companies import finished. Processed %{importCount} rows, with %{errorCount} errors.",
        progress:
          "Imported %{importCount} / %{rowCount} companies, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure you provided a valid CSV file.",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint:
          "Use the sample CSV as a column template. Existing companies are updated by Tax ID or exact name; new companies are created.",
        stop: "Stop import",
        csv_file: "CSV File",
      },
    },
    audit_research_directory: {
      name: "Research entry |||| Research directory",
      nav: "Research",
      title: "Auditors, experts and professional communities",
      company_section: "Auditors and public channels",
      company_social:
        "%{smart_count} public channel |||| %{smart_count} public channels",
      company_auditors: "%{smart_count} auditor |||| %{smart_count} auditors",
      ceased_company_people_notice:
        "People are retained as historical records; current employment is not confirmed after the company's SRO membership ceased.",
      view_company_entries:
        "View %{smart_count} directory entry |||| View all %{smart_count} directory entries",
      open: "Open profile",
      source: "Evidence",
      fields: {
        record_kind: "Category",
        name: "Person or channel",
        company_name: "Company",
        company_ornz: "Company ORNZ",
        role_or_audience: "Role or audience",
        person_ornz: "Person ORNZ",
        certificate_number: "Certificate",
        employment_type: "Employment",
        platform: "Platform",
        contact_url: "Public profile",
        source_url: "Evidence source",
        source_type: "Source type",
        confidence: "Confidence",
        checked_at: "Checked at",
      },
      kinds: {
        manager: "Manager",
        auditor: "Auditor",
        expert: "Expert",
        company_social: "Company channel",
        expert_social: "Expert channel",
        community: "Community",
      },
      confidence: {
        high: "High confidence",
        medium: "Medium confidence",
        low: "Low confidence",
      },
      employment: {
        primary: "Primary employment",
        part_time: "Part-time employment",
      },
    },
    company_interactions: {
      name: "Interaction |||| Interactions",
      title: "Interactions",
      subtitle:
        "Calls, presentations, demos, contracts, invoices, support and upsells.",
      tab: "Interactions",
      empty: "No interactions yet.",
      load_error: "Could not load interactions.",
      created: "Interaction added",
      action: {
        add: "Add",
        add_report: "Add report",
        save_report: "Save report",
      },
      dialog: {
        create_for: "Add interaction: %{name}",
        report_for: "Company report",
      },
      overview: {
        stage: "Stage",
        latest: "Last touch",
        next_step: "Next step",
        status: "Status",
        no_deal: "No deal",
        no_interactions: "No interactions",
        no_next_step: "No next step",
        overdue: "Overdue",
        on_track: "On track",
        has_next_step: "Next action planned",
      },
      linked: {
        contact: "Contact: %{name}",
        deal: "Deal: %{name}",
      },
      fields: {
        company_id: "Company",
        contact_id: "Contact",
        deal_id: "Deal",
        type: "Type",
        interaction_date: "Date",
        summary: "What happened",
        result: "Result",
        next_step: "Next step",
        next_step_date: "Next step date",
        sales_id: "Responsible manager",
      },
      types: {
        call: "Call",
        message: "Message",
        email: "Email",
        meeting: "Meeting",
        presentation_sent: "Presentation sent",
        demo_scheduled: "Demo scheduled",
        demo_done: "Demo done",
        contract_preparation: "Contract preparation",
        invoice_sent: "Invoice sent",
        payment_received: "Payment received",
        implementation: "Implementation",
        support: "Support",
        feature_presentation: "New feature presentation",
        upsell: "Upsell",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
        button: "Import CSV",
        complete:
          "Contacts import complete. Imported %{importCount} contacts, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} contacts, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure your provided a valid CSV file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV File",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
      editor: {
        slash_hint: "Blocks",
        commands: {
          paragraph: "Text",
          heading_1: "Heading 1",
          heading_2: "Heading 2",
          bullet_list: "Bullet list",
          ordered_list: "Numbered list",
          quote: "Quote",
          code: "Code block",
          divider: "Divider",
        },
        command_descriptions: {
          paragraph: "Plain text paragraph",
          heading_1: "Large section heading",
          heading_2: "Medium section heading",
          bullet_list: "Create a simple list",
          ordered_list: "Create a numbered list",
          quote: "Highlight an important fragment",
          code: "Monospace block",
          divider: "Separate sections",
        },
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Atomic CRM",
    },
    common: {
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Atomic CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    header: {
      import_data: "Import data",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    mobile_navigation: {
      more: "More",
    },
    knowledge_base: {
      articles_count: "articles",
      back_to_index: "Knowledge base",
      description:
        "Product and business materials for Doka: strategy, planning, competitor analysis, and internal methodology.",
      open_article: "Open",
      section_label: "Internal materials",
      title: "Knowledge Base",
      updated: "Updated",
    },
    mail: {
      tab: "Email",
      account: {
        title: "IMAP/SMTP email",
        description:
          "Connect a mailbox through IMAP and SMTP to receive and send email from the CRM.",
        connect: "Connect email",
        connected: "Email connected",
        disconnected: "Mailbox disconnected",
      },
      sync: {
        complete: "Sync completed: %{count} new messages",
      },
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Atomic CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
        tokens: {
          title: "Personal access tokens",
          description:
            "Create a revocable token for an MCP client. The token has the same CRM permissions as your account.",
          name: "Token name",
          name_placeholder: "For example, Codex on Mac",
          expires: "Expires",
          days: "%{days} days",
          create: "Create",
          created: "MCP token created",
          copy_now: "Copy this token now",
          shown_once:
            "It will not be shown again after you close this message.",
          empty: "You have no personal MCP tokens yet.",
          load_error: "Could not load MCP tokens.",
          expires_at: "Expires %{date}",
          last_used: "Last used %{date}",
          revoke: "Revoke token",
          revoke_confirm: "Revoke token “%{name}”? This cannot be undone.",
          revoked: "MCP token revoked",
          status: {
            active: "Active",
            expired: "Expired",
            revoked: "Revoked",
          },
        },
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
